import { Platform } from 'api/services';

export const INITIAL_PLATFORM_FILTER: Platform[] = [
  'Mobile',
  'Other',
  'PC',
  'Tablet',
];
